// 该文件需要保持对项目其它文件0引用，避免产生循环依赖
import { isBoolean, isUndefined } from 'lodash';
export var WujiScene;
(function (WujiScene) {
    WujiScene["Runtime"] = "runtime";
    WujiScene["Editor"] = "editor";
})(WujiScene || (WujiScene = {}));
export var DynamicSource;
(function (DynamicSource) {
    DynamicSource["TDesignMessage"] = "tdesign-message";
    DynamicSource["TDesign"] = "tdesign";
})(DynamicSource || (DynamicSource = {}));
class DynamicSourceManager {
    callbackMap = {};
    sourceReadyMap = {};
    dynamicSourceMap = {};
    wujiScene;
    setSceneExecCount = 0;
    get isInitialized() {
        return !isUndefined(this.wujiScene);
    }
    get isEditor() {
        return this.wujiScene === WujiScene.Editor;
    }
    get isRuntime() {
        return this.wujiScene === WujiScene.Runtime;
    }
    setScene = (scene) => {
        if (this.setSceneExecCount > 0) {
            throw new Error('DynamicSourceManager.setScene should only be called once');
        }
        this.wujiScene = scene;
        this.setSceneExecCount += 1;
    };
    getDynamicSource = (sourceName) => this.dynamicSourceMap[sourceName];
    // 有source为加载成功，无source为加载失败
    whenReady = (sourceName, callback) => {
        const ready = this.sourceReadyMap[sourceName];
        // 不需要加载该资源或资源已加载
        if (this.isInitialized && (!isBoolean(ready) || ready)) {
            callback();
            return;
        }
        // 待资源加载完成后执行
        if (!this.callbackMap[sourceName]) {
            this.callbackMap[sourceName] = [];
        }
        this.callbackMap[sourceName].push(callback);
    };
    clearCallback = (name, source) => {
        const callbacks = this.callbackMap[name];
        while (callbacks?.length) {
            callbacks.shift()?.(source);
        }
        delete this.callbackMap[name];
    };
    getCurrentDependencies = () => Object.keys(this.callbackMap);
    // 加载失败仍需执行callback
    loadDynamicSource = (importer) => {
        const { name } = importer;
        this.sourceReadyMap[name] = false;
        const promise = importer.import().then(source => source, () => undefined)
            .then((source) => {
            this.dynamicSourceMap[name] = source;
            this.sourceReadyMap[name] = true;
            // 依赖加载完成后清空依赖
            this.clearCallback(name, source);
            return source;
        });
        return promise;
    };
}
export const dynamicSourceManager = new DynamicSourceManager();
